import React from 'react'

import { CircleLoader, Div } from '@driftt/tide-core'

import './style.css'

const ChartLoader = () => (
  <Div className="chart-loader">
    <CircleLoader />
  </Div>
)

export default ChartLoader
